import { TAny } from '../types/blog';
import errorMessage from './errorMessage';

export const isFileValid = (
  file: File,
  validFormats: string[],
  sizeLimitInMegabytes: number,
  formatErrorMessage: string,
  sizeErrorMessage: string
) => {
  const isFormatCorrect = validFormats.includes(file.type);
  const isSizeValid = file.size / 1024 / 1024 < sizeLimitInMegabytes;
  if (!isFormatCorrect) {
    errorMessage(formatErrorMessage);
    return false;
  }
  if (!isSizeValid) {
    errorMessage(sizeErrorMessage);
    return false;
  }
  return true;
};

export const isValidFile = ({
  file,
  formatErrorMessage = 'Solo puedes subir archivos JPG/PNG!',
  sizeErrorMessage = 'La imagen debe pesar menos de 2MB!'
}: {
  file: File | any;
  formatErrorMessage?: string;
  sizeErrorMessage?: string;
}) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isJpgOrPng) {
    errorMessage(formatErrorMessage);
    return false;
  }
  if (!isLt2M) {
    errorMessage(sizeErrorMessage);
    return false;
  }
  return true;
};

const generateTemporalUrl = (file: TAny) => {
  const base64File: string = URL.createObjectURL(file);
  return base64File;
};

export const validateImg = (file: TAny, isBlogImage?: boolean) => {
  const fileToValidate = isBlogImage ? file?.target?.files[0] : file;
  const isValid = isValidFile({ file: fileToValidate });
  if (isValid) {
    const url = generateTemporalUrl(fileToValidate);
    return { file: fileToValidate, temporalUrl: url };
  }
};

export const validFormatsForDocumentsIncludingImages = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'image/gif',
  'image/tiff',
  'image/svg+xml'
];

export const validFormatsForDocumentsOnlyPdf = ['application/pdf'];

export const validFormatsForCsv = ['text/csv', 'application/vnd.ms-excel'];

export const formatErrorTextForImageDocuments =
  'El documento debe estar en formato PDF o alguno de estos formatos de imagen: png, jpeg, jpg, webp, gif, tiff, svg';

export const errorTextOnlyPdf = 'El documento debe estar en formato PDF';

export const formatErrorTextForCsv = 'El archivo debe estar en formato CSV';

export const validateImageOrPdfCallback = (file?: File) => {
  if (!file) return false;
  return isFileValid(
    file,
    validFormatsForDocumentsIncludingImages,
    10,
    formatErrorTextForImageDocuments,
    'El documento no debe superar los 10MB'
  );
};

export const validateCsvCallback = (file?: File) => {
  if (!file) return false;
  return isFileValid(file, validFormatsForCsv, 5, formatErrorTextForCsv, 'El archivo no debe superar los 5MB');
};

export const verifyFileDocument = (file: File) => {
  const extension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
  const isDocument = extension === '.docx' || extension === '.pdf';
  const size = file.size / 1024 / 1024 < 3;
  if (!isDocument) {
    errorMessage('solo puedes subir archivos .docx/.pdf');
    return true;
  } else if (!size) {
    errorMessage('el archivo debe pesar menos de 3MB');
  }
  return false;
};

export const isValidUrl = (url: string): boolean => {
  const regex = /^(https?:\/\/)([^\s$.?#].[^\s]*)$/i;
  return regex.test(url);
};
